import React from 'react';
import ControlPanel from '../common/ControlPanel';

const controls = [
  // System controls
  { key: 'power_onoff', label: 'Power On/Off', type: 'toggle', reg: 31 },
  { key: 'lock', label: 'Device Lock', type: 'toggle', reg: 13 },
  { key: 'external_control', label: 'External Control', type: 'toggle', reg: 201, description: 'Must enable before set_power works' },
  { key: 'work_mode', label: 'Work Mode', type: 'select', reg: 56, options: [
    { value: 0, label: 'Self Use' },
    { value: 1, label: 'TOU Balance' },
    { value: 2, label: 'TOU Eco' },
    { value: 3, label: 'Backup Power' },
    { value: 4, label: 'Grid Priority' },
  ]},
  { key: 'set_power', label: 'Power Setpoint', type: 'number', reg: 202, min: -30, max: 30, step: 0.1, unit: 'kW', scale: 10, scaleNote: '+discharge / -charge' },
  { key: 'max_grid_input', label: 'Max Grid Input', type: 'number', reg: 197, min: 0, max: 30, step: 0.1, unit: 'kW', scale: 10 },
  { key: 'max_grid_output', label: 'Max Grid Output', type: 'number', reg: 198, min: 0, max: 30, step: 0.1, unit: 'kVA', scale: 10 },

  // Battery 1 config
  { key: 'bat1_discharge_cutoff', label: 'Bat1 Discharge Cutoff', type: 'number', reg: 169, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat1_overvoltage', label: 'Bat1 Overvoltage', type: 'number', reg: 173, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat1_undervoltage', label: 'Bat1 Undervoltage', type: 'number', reg: 174, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat1_max_charge_current', label: 'Bat1 Max Charge I', type: 'number', reg: 175, min: 0, max: 100, step: 0.1, unit: 'A', scale: 10 },
  { key: 'bat1_max_discharge_current', label: 'Bat1 Max Discharge I', type: 'number', reg: 176, min: 0, max: 100, step: 0.1, unit: 'A', scale: 10 },
  { key: 'bat1_max_charge_power', label: 'Bat1 Max Charge P', type: 'number', reg: 177, min: 0, max: 30000, step: 100, unit: 'W', scale: 1 },
  { key: 'bat1_max_discharge_power', label: 'Bat1 Max Discharge P', type: 'number', reg: 178, min: 0, max: 30000, step: 100, unit: 'W', scale: 1 },

  // Battery 2 config
  { key: 'bat2_discharge_cutoff', label: 'Bat2 Discharge Cutoff', type: 'number', reg: 209, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat2_overvoltage', label: 'Bat2 Overvoltage', type: 'number', reg: 213, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat2_undervoltage', label: 'Bat2 Undervoltage', type: 'number', reg: 214, min: 200, max: 500, step: 0.1, unit: 'V', scale: 10 },
  { key: 'bat2_max_charge_current', label: 'Bat2 Max Charge I', type: 'number', reg: 215, min: 0, max: 100, step: 0.1, unit: 'A', scale: 10 },
  { key: 'bat2_max_discharge_current', label: 'Bat2 Max Discharge I', type: 'number', reg: 216, min: 0, max: 100, step: 0.1, unit: 'A', scale: 10 },
  { key: 'bat2_max_charge_power', label: 'Bat2 Max Charge P', type: 'number', reg: 217, min: 0, max: 30000, step: 100, unit: 'W', scale: 1 },
  { key: 'bat2_max_discharge_power', label: 'Bat2 Max Discharge P', type: 'number', reg: 218, min: 0, max: 30000, step: 100, unit: 'W', scale: 1 },
];

// inverter1 = com2, inverter2 = com4
const comMap = { inverter1: 'com2', inverter2: 'com4' };

function buildDesired(values, inverter) {
  const com = comMap[inverter];
  const desired = { inverter: { [com]: { cmd: {} } } };
  for (const [key, value] of Object.entries(values)) {
    const ctrl = controls.find(c => c.key === key);
    if (!ctrl) continue;
    const scaledValue = ctrl.scale ? Math.round(value * ctrl.scale) : value;
    desired.inverter[com].cmd[key] = { reg: ctrl.reg, value: scaledValue };
  }
  return desired;
}

export default function InverterControlPanel({ inverter = 'inverter2' }) {
  return (
    <ControlPanel
      title={`${inverter.replace('inverter', 'Inverter ')} Controls (${comMap[inverter]})`}
      controls={controls}
      buildDesired={(values) => buildDesired(values, inverter)}
    />
  );
}
